module.exports = __webpack_public_path__ + "static/img/ico_app_qx_code.e83a447.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/application/ico_app_qx_code.png
// module id = boA+
// module chunks = 0